<template>
  <el-row class="allocation-details">
    <el-col :span="12" class="allocation-details-left">
      <el-row>
        <el-col :span="8"><InputLabel value="Budget Fiscal Year:"></InputLabel></el-col>
        <el-col :span="16">{{program.bfy}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8"><InputLabel value="Program ID:"></InputLabel></el-col>
        <el-col :span="16">
          <el-tooltip :content="program.programLabel" placement="top">
            <el-input
              class="program-readonly"
              size="small"
              readonly
              v-model="program.programLabel">
            </el-input>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8"><InputLabel value="Lapse Date:"></InputLabel></el-col>
        <el-col :span="6">{{program.lapseDate | moment("MM/DD/YYYY")}}</el-col>
        <el-col :span="4"><InputLabel value="Carryover:"></InputLabel></el-col>
        <el-col :span="6">{{program.carryover}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8"><InputLabel value="MOF:"></InputLabel></el-col>
        <el-col :span="6">{{program.meansOfFinance}}</el-col>
        <el-col :span="6"><InputLabel value="Appropriation Code:"></InputLabel></el-col>
        <el-col :span="4">{{program.appropriationCode}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8"><InputLabel value="B&F SubOrg:"></InputLabel></el-col>
        <el-col :span="16">{{program.bfSubOrg}}</el-col>
      </el-row>
    </el-col>
    <el-col :span="12">
      <el-row>
        <el-col :span="8"><InputLabel value="Allocation Number:"></InputLabel></el-col>
        <el-col :span="16">{{allocation.caseNumber}}</el-col>
      </el-row>
      <el-row v-if="allocation.approvedDate">
        <el-col :span="8"><InputLabel value="Allocation Date:"></InputLabel></el-col>
        <el-col :span="16">{{allocation.approvedDate | moment("MM/DD/YYYY")}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8"><InputLabel value="Allocation Type:"></InputLabel></el-col>
        <el-col :span="16">{{allocation.allocationSubtype}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8"><InputLabel value="Program Manager:"></InputLabel></el-col>
        <el-col :span="16">{{allocation.programManagerName}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="8"><InputLabel value="Managing Office:"></InputLabel></el-col>
        <el-col :span="16">{{allocation.managingOfficeName}}</el-col>
      </el-row>
      <el-row v-if="!isCompleted && isAppropriation">
        <el-col :span="8"><InputLabel value="Do Not Load:"></InputLabel></el-col>
        <el-col :span="16">{{noLoadText}}</el-col>
      </el-row>
      <el-row v-if="isAppropriation">
        <el-col :span="8"><InputLabel value="Adjust OA:"></InputLabel></el-col>
        <el-col :span="16">{{adjustOAText}}</el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import InputLabel from '../misc/InputLabel.vue';
import api from '../../utils/api';
import Constants from '../../constants';
import * as Paths from '../../constants/paths';

export default {
  name: 'AllocationDetails',
  components: {
    InputLabel,
  },
  props: {
    type: {
      type: String,
      required: true,
      default: '',
      validator(value) {
        return [
          Constants.ALLOCATION_TYPES.APPROPRIATION,
          Constants.ALLOCATION_TYPES.DECREASE,
          '',
        ].indexOf(value) !== -1;
      },
    },
    allocation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    adjustOAText() {
      return this.allocation.isAdjustOA ? 'Yes' : 'No';
    },
    noLoadText() {
      return this.allocation.noLoadFlag ? 'Yes' : 'No';
    },
    isAppropriation() {
      return this.type === Constants.ALLOCATION_TYPES.APPROPRIATION;
    },
    isCompleted() {
      return this.allocation.status === 'F';
    },
  },
  data() {
    return {
      program: {},
      createAllowed: false,
      bfy: '',
      selectedProgram: '',
      isProgramSelected: false,
    };
  },
  methods: {
    getAndSetProgram(programId, bfy) {
      if (programId && bfy) {
        api.get(Paths.PROGRAM_URL(programId, bfy)).then((response) => {
          this.program = response.data.data;
          this.$emit('program-changed', this.program);
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .allocation-details {
    margin-top: 10px;
    padding: 40px;
    background: rgba(238, 245, 247, 0.5);
    border: 1px solid #748C9C;
    box-sizing: border-box;
    border-radius: 4px;

    .allocation-details-left {
      padding-right: 40px;

      .edit-program-btn {
        padding-left: 10px;
        font-size: 14px;
      }
    }

    .el-row {
      height: 36px;
      margin: 8px 0;

      .dropdown-select {
        width: 100%;
      }

      .program-readonly {
        padding-bottom: 3px;
        /deep/ .el-input__inner {
          color: white;
          border: none;
          background: #748C9C;
        }
      }
    }
  }
</style>
